import React from 'react'
import {Navbar, Container} from 'react-bootstrap';

function SimpleNavbar({navData}) {
    
    const {sections} = navData || {};
    //eslint-disable-next-line no-unused-vars
    const [navbar_header, navbar_left, navbar_right, dropdown_menu] = sections || []; 

    const {links: navbar_links} = navbar_header || [];
    const [navbar_links_obj] = navbar_links || [];
    const {src: navbar_src} = navbar_links_obj || '';


  return (
    <Navbar variant="dark"className="navbar-custom navbar-inverse" id="navbar" expand="md">
        <Container>
            <Navbar.Brand className="navbar-header">
                <img src={navbar_src} alt='Specprawnik.pl'/>
            </Navbar.Brand>
        </Container>
    </Navbar>
  )
}

export default SimpleNavbar